import React, {PropsWithChildren} from 'react'
import {Button, ButtonPriority, HoverStyles, PaddingModes} from 'wix-ui-tpa/cssVars'

import {classes, st} from './ReserveButton.st.css'
import {reserveButtonDataHooks} from './constants'

interface Props {
  onClick?: () => void
  width?: number
  className?: string
}

export const ReserveButton = ({onClick, children, width, className}: PropsWithChildren<Props>) => {
  return (
    <div className={st(classes.container)}>
      <Button
        className={st(classes.root, className)}
        priority={ButtonPriority.primary}
        hoverStyle={HoverStyles.underline}
        paddingMode={PaddingModes.explicitPaddings}
        onClick={onClick}
        type="submit"
        style={{
          ...(width ? {width: `${width}px`} : {}),
        }}
        data-hook={reserveButtonDataHooks.button()}
      >
        {children}
      </Button>
    </div>
  )
}
